// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
// Endpoint to get report config
export const sampleReportUrl = 'https://aka.ms/CaptureViewsReportEmbedConfig';
